import { BaseWebComponentElement } from '../../framework/BaseWebComponentElement';
import { AlertsDetailsPanelController } from '../controller/AlertsDetailsPanelController';
import { ColumnDetails } from '@nirvana/shared/dtos/types/alerts/common';

export class AlertsDetailsPanelComponent extends BaseWebComponentElement {
  private _eventId: string;
  private _allColumnsDetails: Array<ColumnDetails>;
  private _isPartner: boolean;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: AlertsDetailsPanelController,
    });
  }

  get eventId(): string {
    return this._eventId ?? '';
  }

  set eventId(value: string) {
    this._eventId = value;
  }

  get allColumnDetails(): Array<ColumnDetails> {
    return this._allColumnsDetails ?? [];
  }

  set allColumnDetails(value: Array<ColumnDetails>) {
    this._allColumnsDetails = value;
  }

  public get isPartner(): any {
    return this._isPartner;
  }

  public set isPartner(value: boolean) {
    this._isPartner = value;
  }
}
